import { OutProductExtendedViewDTO, ProductsApi } from "@app/bf-api";
import { moduleMapperThrowMessage } from "@app/api/wp-page-fetcher/utils/module-mapper-error-handling";
import Logger from "@app/util/logger";

export const singleProductGetApi = async (
  slug: string,
  platformId: number
): Promise<OutProductExtendedViewDTO | undefined> => {
  try {
    const api = new ProductsApi();

    const product = await api.getProductBySlug({ productSlug: slug, platformId, extendedView: true });

    if (!product) return moduleMapperThrowMessage("Cannot get single product");

    return product;
  } catch (e) {
    Logger.logError(e, "Error in: singleProductGetApi");

    return undefined;
  }
};
